<template>
  <aside class="sidebar-section">
    <div class="progress-card">
      <h3>Progression Globale</h3>
      <div class="xp-bar">
        <div class="xp-fill" :style="{ width: xpPercent + '%' }"></div>
      </div>
      <p class="xp-text">{{ user.xp }} / {{ user.xpMax }} XP jusqu'au niveau {{ user.level + 1 }}</p>
    </div>
    <div class="progress-card">
      <h3>Mes Badges</h3>
      <div class="badges">
        <div v-for="(badge, i) in user.badges" :key="i" :class="['badge', { earned: badge.earned }]">
          <div class="badge-icon">{{ badge.icon }}</div>
          <div class="badge-name">{{ badge.name }}</div>
        </div>
      </div>
    </div>
    <ul class="nav-menu">
      <li class="active">📚 Mes Apprentissages</li>
      <li>✅ Mes Compétences</li>
      <li>🏆 Défis en Cours</li>
      <li>📊 Mes Statistiques</li>
      <li>👥 Classement</li>
      <li>⚙️ Paramètres</li>
    </ul>
  </aside>
</template>
<script>
export default {
  name: "SidebarSection",
  props: {
    user: { type: Object, required: true },
  },
  computed: {
    xpPercent() {
      return Math.round((this.user.xp / this.user.xpMax) * 100)
    },
  },
}
</script>
<style scoped>
.sidebar-section {
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: fit-content;
}
.progress-card {
  margin-bottom: 25px;
}
.progress-card h3 {
  color: #2d3748;
  font-size: 16px;
  margin-bottom: 15px;
}
.xp-bar {
  background: #e2e8f0;
  height: 12px;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 8px;
}
.xp-fill {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  height: 100%;
  border-radius: 20px;
  transition: width 0.5s ease;
}
.xp-text {
  color: #718096;
  font-size: 13px;
}
.badges {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 15px;
}
.badge {
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}
.badge:hover {
  border-color: #667eea;
  transform: translateY(-3px);
}
.badge.earned {
  background: linear-gradient(135deg, #ffd89b 0%, #19547b 100%);
  border-color: #f59e0b;
}
.badge-icon {
  font-size: 28px;
  margin-bottom: 5px;
}
.badge-name {
  font-size: 10px;
  color: #4a5568;
  font-weight: 600;
}
.nav-menu {
  list-style: none;
  margin-top: 25px;
}
.nav-menu li {
  padding: 12px 15px;
  margin-bottom: 5px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  color: #4a5568;
  display: flex;
  align-items: center;
  gap: 10px;
}
.nav-menu li:hover {
  background: #f7fafc;
}
.nav-menu li.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}
</style>
